// eslint-disable-next-line no-use-before-define
import React from 'react';

const SkeletonMessage = () => {
  return (
    <div className="flex p-16 items-center">
      <div
        style={{ minWidth: '56px', minHeight: '56px', maxWidth: '56px', maxHeight: '56px' }}
        className="animate-pulse bg-grey-divider-subdued rounded-full mr-8"
      />
      <div className="flex flex-col w-full">
        <div className="flex flex-row justify-between">
          <div style={{ width: '72px', height: '20px' }} className="animate-pulse bg-grey-divider-subdued mb-8" />
          <div style={{ width: '48px', height: '20px' }} className="animate-pulse bg-grey-divider-subdued" />
        </div>
        <div style={{ width: '100%', height: '20px' }} className="animate-pulse bg-grey-divider-subdued mb-8" />
        <div style={{ width: '90%', height: '20px' }} className="animate-pulse bg-grey-divider-subdued" />
      </div>
    </div>
  );
};

export default SkeletonMessage;
